import React from "react";
// import Logo from "../../assets/images/Logo/Logo.png";
import { Stack, Button, Box } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

export const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Stack direction="column" alignItems="center">
        {/* <img
          src={Logo}
          alt="logo"
          style={{
            width: "100px",
          }}
        /> */}
        <WarningAmberRoundedIcon sx={{ fontSize: 80, color: "#BDBDBD" }} />
        <p>Something went wrong</p>
        <Button
          type="button"
          size="medium"
          variant="text"
          color="info"
          onClick={() => window.location.reload()}
        >
          Retry
        </Button>
      </Stack>
    </Box>
  );
};
